<div id="aowInfo" class="ap-margin-1">
    @if (showForBothApplicants()) {
        <extra-information [textType]="textType.INFO" [tipContent]="'income.aow-info.both-applicants' | apContent"></extra-information>
    }
    @if (showForMainApplicantOnly()) {
        <extra-information [textType]="textType.INFO" [tipContent]="'income.aow-info.main-applicant' | apContent"></extra-information>
    }
    @if (showForCoApplicantOnly()) {
        <extra-information [textType]="textType.INFO" [tipContent]="'income.aow-info.co-applicant' | apContent"></extra-information>
    }
</div>
@if ((store.isSummary() | async) === false) {
    <next-button (click)="nextQuestion()"></next-button>
}
